"use strict";

const { pageViewEvent, promotionEvents, searchEvent } = require("../helpers/gtmHelpers");

module.exports = function () {
    const storePageWrapper = $(".storepage");
    const customPageName = storePageWrapper.attr("id") === "404error" ? "404" : "Custom";
    const pageName = storePageWrapper.attr("id") === "homepage" ? "Homepage" : customPageName;
    const components = [".image-and-overlay", ".hero-banner", ".slim-hero-container", ".primary-background", ".youtube-video", ".ITC-container"];
    pageViewEvent(pageName);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                promotionEvents("view_promotion", entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    components.forEach((component) => {
        const element = document.querySelectorAll(component);

        element.forEach((el) => {
            const isPromotion = el.getAttribute("data-ispromotion");
            const wrapperLink = el.querySelector(".wrapper-link");
            const customLinks = el.querySelectorAll(".custom-link");
            const buttons = el.querySelectorAll(".experience-commerce_assets-button");
            observer.observe(el);

            if (isPromotion === "true" && wrapperLink) {
                wrapperLink.addEventListener("click", function () {
                    promotionEvents("select_promotion", el);
                });
            }

            if (customLinks.length > 0 && isPromotion === "true") {
                customLinks.forEach((link) => {
                    link.addEventListener("click", function () {
                        promotionEvents("select_promotion", el);
                    });
                });
            }

            if (buttons.length > 0 && isPromotion === "true") {
                buttons.forEach((button) => {
                    button.addEventListener("click", function () {
                        promotionEvents("select_promotion", el);
                    });
                });
            }
        });
    });

    // GTM Search event on storepages
    $(".header-search-form").on("submit", searchEvent);
};
